import UrlBuilder      from '../../utils/UrlBuilder.js';
import Flux                     from '../../flux/Flux.js';
import {_KEYS, mapCategoryToV2, getHiddenTagsForCategory} from '../Video/VideoHelper.js';
import {isObjectEmpty}          from '../../utils/CommonUtils.js';


const CAMS   = 'CAMS';
const VIDEOS = 'VIDEOS';

function getFilter(FILTER) {
    return structuredClone(FILTER).map(filter => {
        const newFilter = filter;
        newFilter.tags.map(tag => {
            const newTag         = tag;
            newTag.category      = filter.headline;
            newTag.categoryShort = filter.headlineShort;
            return newTag;
        });
        return newFilter;
    });
}

function getFilterFromUrl(isHomepage, filterParam, stateFilter, page, forcedFilter = null) {
    const path          = location.pathname.replace(getBaseUrl(isHomepage, page), '').slice(0, -1);
    const urlTags       = path ? path.replace('_', ' ').split('+') : [];
    const urlParams     = getUrlParams();
    const urlFilter     = getFilterParam(filterParam);
    const filter        = structuredClone(forcedFilter || stateFilter);
    const tags          = [];
    const defaultFilter = getHiddenTagsForCategory(mapCategoryToV2(page));

    filter.map(item => item.tags.map(tag => {
        if (tag.type === 'tag' && (urlFilter[tag.key] && urlFilter[tag.key].includes(tag.value) || urlTags.includes(tag.text.toLowerCase()))) {
            tag.isActive = true;
            tags.push(tag.text);
        } else if (urlFilter[tag.key] && urlFilter[tag.key].includes(tag.value.KEY)) {
            tag.isActive = true;
        } else if (tag.key === 'gender' && urlFilter[tag.key] && !urlFilter[tag.key].includes('F')) {
            tag.isActive = false;
        } else if (tag.type === _KEYS.DEFAULT_FILTER_TYPE && (urlParams.includes(filterParam) || (urlFilter && urlFilter.hasOwnProperty('types'))) && !defaultFilter.includes(tag.value.KEY)) {
            if ((urlFilter.hasOwnProperty('types') && urlFilter.types.includes(tag.value.KEY))) {
                tag.isActive = true;
            } else if (urlParams.includes(filterParam) && isObjectEmpty(urlFilter)) {
                tag.isActive = false;
            } else {
                tag.isActive = false;
            }
        }
    }));
    const activeFilter = getActiveFilter(filter);
    if (tags.length > 0) {
        return Promise.resolve(getSeo(filter, activeFilter, tags, isHomepage, page));
    } else {
        return Promise.resolve({filter, activeFilter, loading: false});
    }
}

function getActiveFilter(filter) {
    const activeFilter = [];

    filter.map((item) => {
        item.tags.map((tag) => {
            if (tag.isActive) {
                activeFilter.push(tag);
            }
        });
    });

    return activeFilter;
}

function getBaseUrl(isHomepage, type) {
    if (isHomepage) {
        return UrlBuilder.buildHomepageRoute();
    }

    switch (type) {
        case Flux.Constants.Video.Categories.ALL:
            return UrlBuilder.buildVideoAllRoute();
        case Flux.Constants.Video.Categories.NEWEST:
            return UrlBuilder.buildVideosNewRoute();
        case Flux.Constants.Video.Categories.ON_SALE:
            return UrlBuilder.buildVideosSaleRoute();
        case Flux.Constants.Video.Categories.TRENDING:
            return UrlBuilder.buildVideosTrendingRoute();
        case Flux.Constants.Video.Categories.FREE_WEEKLY:
            return UrlBuilder.buildFreeVideosRoute();
        default:
            return UrlBuilder.buildCamsRoute();
    }
}


function getFilterParam(filterParam) {
    const url       = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);

    try {
        return JSON.parse(urlParams.get(filterParam)) || {};
    } catch (error) {
        console.error('Error parsing filter parameter:', error);
        return {};
    }
}

function getUrlParams() {
    const url       = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);

    try {
        return urlParams.toString() || '';
    } catch (error) {
        console.error('Error parsing filter parameter:', error);
        return {};
    }
}

function getSeo(filter, activeFilter, tags, isHomepage, page, filterParam = null, updateUrl = false) {
    return new Promise((resolve) => {
        Flux.Seo.getSeo(tags, (res) => {
            const data = res.data.seo.texts.fromTags;
            if (updateUrl) {
                let url = '';
                if (isHomepage) {
                    url = getBaseUrl(isHomepage, page);
                } else {
                    url = (getBaseUrl(isHomepage, page)) + data.slug.replace(' ', '_') + '/';
                }
                setFilterParam(activeFilter, filterParam, url);
            }
            document.title       = data.seoTitle;
            document.description = data.seoDescription;

            const seoData = {filter, activeFilter, loading: false, ...data};
            resolve(seoData);
        });
    });
}

function setFilterParam(activeFilter, filterParam, tagUrl = '') {
    const url    = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const filter = {};
    activeFilter.filter(item => !item.hidden).map(item => {
        if (!filter[item.key]) {
            filter[item.key] = [];
        }
        filter[item.key].push(item.type === 'tag' ? item.value : item.value.KEY);
    });
    params.set(filterParam, JSON.stringify(filter));
    const urlString = tagUrl + '?' + params.toString();
    if (window.history) {
        let state = {};
        if (window.history.state) {
            state     = window.history.state;
            state.url = urlString;
        }
        Flux.Browser.historyReplaceState(state, '', urlString);
    }
}


function setOrderParam(orderParam, order) {
    const url    = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.set(orderParam, order);
    window.history.pushState(window.history.state, '', '?' + params.toString());
}

function getOrderParam(orderParam, defaultOrder, type = CAMS, isOnboarding = false) {
    let order;

    switch (type) {
        case VIDEOS:
            order = Flux.Constants.Vxql.Videos.SortOrders.NEWEST;
            break;
        case CAMS:
        default:
            order = Flux.Constants.Vxql.Actors.Order.GUEST_PREFERENCES;
    }
    const url       = new URL(window.location.href);
    const urlParams = new URLSearchParams(url.search);
    return urlParams.get(orderParam) || isOnboarding ? order : defaultOrder;
}

function getTopFilter(stateFilter) {
    const topFilter = [];
    stateFilter.map(filter => {
        filter.tags.map(tag => {
            if (tag.isTopFilter) {
                topFilter.push(tag);
            }
        });
    });

    return topFilter.sort((a, b) => a.isTopFilter - b.isTopFilter);
}

function getFilterCount(activeFilter) {
    return activeFilter.filter(item => !item.hidden).length;
}

export {
    VIDEOS,
    CAMS,
    getFilter,
    getFilterFromUrl,
    getActiveFilter,
    getBaseUrl,
    getFilterParam,
    getSeo,
    setFilterParam,
    setOrderParam,
    getOrderParam,
    getTopFilter,
    getFilterCount,
};
